import { BadgeColor } from '@billy/design-system'

import { PayrollStatus } from '../../../types/payrollStatus'

export const statusToBadgeColor: Record<PayrollStatus, BadgeColor> = {
  // Success
  [PayrollStatus.Approved]: 'success',
  [PayrollStatus.AutomaticApproval]: 'success',
  [PayrollStatus.Success]: 'success',
  [PayrollStatus.Tentative]: 'success',
  // Warning
  [PayrollStatus.Awaiting]: 'warning',
  [PayrollStatus.AwaitingApproval]: 'warning',
  [PayrollStatus.MissingApproval]: 'warning',
  [PayrollStatus.Reviewed]: 'warning',
  // Error
  [PayrollStatus.Cancelled]: 'danger',
  [PayrollStatus.Failed]: 'danger',
  [PayrollStatus.Rejected]: 'danger',
  [PayrollStatus.Unknown]: 'danger',
}
